export default defineNuxtPlugin(() => {
  const clientId = useRuntimeConfig().public.GOOGLE_CLIENT_ID;

  const loadGoogleScript = () => {
    return new Promise<void>((resolve, reject) => {
      // @ts-expect-error google is not defined in the global scope
      if (window.google?.accounts) return resolve();

      const scriptId = "gsi-client";
      if (document.getElementById(scriptId)) return resolve();

      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      script.id = scriptId;

      script.onload = () => {
        resolve();
      };

      script.onerror = () => {
        reject(new Error("Failed to load Google Sign-In script"));
      };

      document.head.appendChild(script);
    });
  };

  return {
    provide: {
      googleAuth: {
        async init(callback: (credential: string) => void) {
          await loadGoogleScript();

          // @ts-expect-error google is not defined in the global scope
          window.google?.accounts.id.initialize({
            client_id: clientId,
            callback: (response: { credential: string }) => {
              callback(response.credential);
            },
          });
        },
        renderButton(containerId: string) {
          // @ts-expect-error google is not defined in the global scope
          window.google?.accounts.id.renderButton(
            document.getElementById(containerId),
            { theme: "outline", size: "large", shape: "pill" },
          );
        },
      },
    },
  };
});
